export class BaseService {


}



// WEBPACK FOOTER //
// ./~/@c4/core/src/app/services/base.service.ts